// extracted by mini-css-extract-plugin
export default {"footerBottom":"FooterBottom_footerBottom__2pndq"};